// typed wrapper module around the env global js variable

import { IEnv, ITenForceWindow } from "./global"

declare let window: ITenForceWindow
const env: IEnv = window.env

export default env
